
import React from 'react';
import { ErrorBoundary } from './ErrorBoundary';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Home, RefreshCw } from 'lucide-react';
import { Link } from 'react-router-dom';

interface RouteErrorBoundaryProps {
  children: React.ReactNode;
}

const RouteFallback = () => (
  <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
    <Card className="w-full max-w-lg">
      <CardHeader className="text-center">
        <CardTitle className="text-xl font-semibold text-gray-900">
          Page Error
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4 text-center">
        <p className="text-gray-600">
          This page encountered an error and couldn't load properly.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-2">
          <Button 
            onClick={() => window.location.reload()}
            className="flex-1"
          >
            <RefreshCw className="w-4 h-4 mr-2" />
            Refresh Page
          </Button>
          <Button 
            asChild
            variant="outline"
            className="flex-1"
          >
            <Link to="/">
              <Home className="w-4 h-4 mr-2" />
              Go Home
            </Link>
          </Button>
        </div>
      </CardContent>
    </Card>
  </div>
);

export const RouteErrorBoundary: React.FC<RouteErrorBoundaryProps> = ({ children }) => {
  return (
    <ErrorBoundary fallback={<RouteFallback />}>
      {children}
    </ErrorBoundary>
  );
};
